import * as React from 'react';

import { Button } from '../../atoms/button/button';

export interface EmptyCardProps {
	/** Icona mostrata sopra il messaggio (dimensione e colore automatici). */
	icon?: React.ReactNode;
	/** Messaggio che spiega l'assenza di dati. */
	message: React.ReactNode;
	/** Testo del bottone di azione; va passato insieme a `onAction` per mostrarlo. */
	actionLabel?: React.ReactNode;
	/** Chiamata al click sul bottone di azione. */
	onAction?: () => void;
}

/** Card segnaposto a bordo tratteggiato per stati "nessun dato", con azione opzionale (es. "Aggiungi"). */
const EmptyCard = ({ icon, message, actionLabel, onAction }: EmptyCardProps) => (
	<div className="rounded-xl border border-dashed border-border bg-card p-6 text-center">
		{icon && (
			<span className="mx-auto mb-2 block w-fit text-text-muted [&_svg]:h-6 [&_svg]:w-6">
				{icon}
			</span>
		)}
		<p className="mb-3 text-xs text-text-muted">{message}</p>
		{actionLabel && onAction && (
			<Button type="button" variant="accent" size="sm" onClick={onAction}>
				{actionLabel}
			</Button>
		)}
	</div>
);
EmptyCard.displayName = 'EmptyCard';

export { EmptyCard };
